let language = {
    ADD_STORE_PRODUCT_MODAL_SETECT_PRODUCT_TYPE_TITLE:"select store product type",
    ADD_STORE_PRODUCT_MODAL_SETECT_PRODUCT_TYPE_BACK_BTN:"BACK"
    };
    
    export { language }